<template>
  <el-popover
    ref="elPopover"
    :class="{'pop_wrap':true,'in_drop': searchDrop}"
    placement="bottom"
    popper-class="zone_pop_box"
    :width="zoneWidth"
    @show="isShow = true"
    @hide="popHide">
    <div slot="reference">
      <el-tooltip :disabled="tipDisable" effect="light" placement="top-start">
        <div slot="content">{{tipContent}}</div>
        <div class="show_select">
          <div :class="{'sel_items':true,'in_drop': searchDrop}">
            <div v-if="isCheck" ref="itemBox" id="itemBox" :class="{'item_box':true, 'small': size === 'small'}">
              <p
                v-for="(area, idx) in checkItems"
                :class="['s_item',{'in_drop': searchDrop,'divide': lastIdx && idx === lastIdx,'hide': lastIdx && idx > lastIdx}]"
                :style="{'maxWidth': maxItemWidth + 'px'}"
                :ref="area[nodeKey]"
                :key="area[nodeKey]">
                {{(lastIdx && idx === lastIdx)? '...' : area[treeProps.label]}}
                <i v-if="!lastIdx || idx !== lastIdx" :class="['iconfont','icon-shibai',{'small': size === 'small'}]" @click.stop="deleteItem(idx)"></i>
              </p>
            </div>
            <span v-else :class="{'holder_item': true, 'in_drop': searchDrop, 'small': size === 'small'}">{{placeholder}}</span>
          </div>
          <i :class="{'el-icon-arrow-down':true, 'fix_right': searchDrop, 'small': size === 'small', 'reverse':isShow}"></i>
        </div>
      </el-tooltip>
    </div>
    <div class="content_box">
      <el-input
        class="search_input"
        size="mini"
        clearable
        maxlength="100"
        :placeholder="searchPlaceHolder"
        v-model="searchKey"
        @keyup.enter.native="keywordSearch">
        <i slot="suffix" class="el-input__icon el-icon-search" @click.stop="keywordSearch"></i>
      </el-input>
      <div v-show="modeSearch" class="search_result">
        <div v-if="!searchList.length" class="no_result">
          <span>{{searchLoading? '搜索中请稍后' : '无搜索结果'}}</span>
        </div>
        <div v-else class="has_result">
          <div v-show="searchList.length > 100" class="excess_tip">搜索内容过多，只展示前100条记录，请精确关键字</div>
          <div :class="['result_ul', {'many': searchList.length > 100}]">
            <div
              v-for="item in displayList"
              :key="item[nodeKey]"
              class="ul_item"
              @click="locateTreeNode(item)">
              <span
                class="item_name"
                :title="item[treeProps.label].length > 16 ? item[treeProps.label] : ''"
                v-html="item.name">
              </span>
              <span :class="belongClass(item[levelKey])" :title="item.belongs.length > 4 ? item.belongs : ''">{{item.belongs}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="isLocate" class="back_btn" @click="goBackSearchList">
        <i class="el-icon-arrow-left"></i>
        返回“{{locatedStr}}”的搜索结果
      </div>
      <el-tree
        v-show="!modeSearch"
        ref="zoneTree"
        :class="['zone_tree', {'located': isLocate,'in_drop': searchDrop}]"
        accordion
        :show-checkbox="showCheckbox"
        :check-on-click-node="!showCheckbox"
        :expand-on-click-node="showCheckbox"
        :check-strictly="!showCheckbox"
        :props="treeProps"
        :node-key="nodeKey"
        lazy
        :load="loadNode"
        @check-change="checkChange"
        @check="clickCheckBox">
      </el-tree>
      <div class="btn_group">
        <div class="btn_item confirm" @click="confirmAction">{{confirmBtnText}}</div>
        <div class="btn_item" @click="abandSelect">{{cancelBtnText}}</div>
      </div>
    </div>
  </el-popover>
</template>

<script>
import { deepClone } from '@/utils/functions'
const TreeLayerCodes = ['provinceCode', 'cityCode', 'townCode', 'streetCode', 'nbhdCode', 'liftCode'] // 区域树各层级code key

export default {
  name: 'MultiZoneSelector',
  props: {
    searchDrop: {
      type: Boolean,
      default: false
    },
    size: { // 已选项大小(默认高50px, 'small':30px)
      type: String,
      default: 'normal'
    },
    zoneWidth: { // 区域选择器弹出框宽度
      type: [Number, String],
      default: 340
    },
    maxItemWidth: { // 单选模式下已选项的最大宽度
      type: [Number, String],
      required: false,
      default: 120
    },
    showTip: {
      type: Boolean,
      default: false
    },
    confirmBtnText: {
      type: String,
      required: false,
      default: '搜索'
    },
    cancelBtnText: {
      type: String,
      required: false,
      default: '取消'
    },
    placeholder: {
      type: String,
      default: '全国'
    },
    searchPlaceHolder: {
      type: String,
      default: '请输入省/市/区/小区/设备编码'
    },
    checkFirst: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    treeProps: {
      type: Object,
      default () {
        return {
          label: 'districtName',
          children: 'children',
          levelKey: 'districtLevel'
        }
      }
    },
    nodeKey: {
      type: String,
      default: 'districtCode'
    },
    leafLevel: {
      type: Number,
      default () { return 7 }
    },
    loadChildren: { // 懒加载方式:组件调用外部加载数据方法并返回树节点数据，数据直传和懒加载须2选1
      type: Function,
      default () { return node => { return [] } }
    },
    searchMethod: { // 远程搜索区域树方法
      required: true,
      type: Function,
      default () { return str => { return [] } }
    }
  },
  data () {
    return {
      isShow: false,
      needTip: false,
      searchKey: '',
      modeSearch: false, // 当前是否搜索模式
      isLocate: false, // 是否从搜索结果定位到树节点状态
      locatedStr: '', // 搜索结果定位状态展示的关键字
      searchLoading: false, // 是否搜索中
      isLoadData: false,
      searchList: [],
      lastIdx: null,
      checkItems: [], // [{districtCode:330100, districtName:'杭州市', districtLevel:3}]
      emitItems: [] // 最终传递给外部的已选项
    }
  },
  computed: {
    levelKey () {
      return this.treeProps.levelKey
    },
    isCheck () {
      if (this.checkItems && this.checkItems.length) return true
      return false
    },
    tipDisable () {
      if (!this.showTip || !this.isCheck) {
        return true
      } else {
        return !this.needTip
      }
    },
    tipContent () {
      let names = this.checkItems.map(k => k[this.treeProps.label])
      if (names && names.length) return names.join('、')
      return ''
    },
    displayList () {
      return this.searchList.length > 100 ? this.searchList.slice(0, 100) : this.searchList
    }
  },
  watch: {
    searchKey (val) {
      if (!val) {
        this.clearSearch()
      }
    }
  },
  beforeDestroy () {
    this.$root.$off('refreshCheckedZone') // 移除该事件的所有监听器
  },
  mounted () {
    if (this.isCheck) this.isOverlength()
    this.$root.$on('refreshCheckedZone', () => {
      /**
       * 监听根元素发出的事件,在回调中重新计算已选项的布局
       * 保证在屏幕/摄像头截图tab下展开地区选择器并去勾选已选地区后直接切换到别的tab页，
       * 然后再返回屏幕/摄像头截图tab页时,已选地图的布局是正常的
       */
      this.$nextTick(() => { this.isOverlength() })
    })
  },
  methods: {
    clear () {
      this.checkItems = []
      this.emitItems = []
      this.$refs.zoneTree.setCheckedKeys([])
    },
    popHide () {
      this.isShow = false
      this.checkItems = deepClone(this.emitItems)
      let preKeys = this.emitItems.map(t => t[this.nodeKey])
      this.$refs.zoneTree.setCheckedKeys(preKeys)
      this.$nextTick(() => { this.isOverlength() })
    },
    async checkTargetProCityTown (targetArea) { // 单选模式下由外部指定要勾选的区域(省、市、区级别)
      let cks = targetArea[this.nodeKey]
      // 目标区域无nodeKey属性 或 目标区域不存在区域名称，则判定为非法数据
      if (!cks || !targetArea[this.treeProps.label]) {
        console.warn('非法的目标区域数据:', targetArea)
        return
      }
      this.checkItems = [targetArea]
      this.emitItems = [targetArea]
      await this.locateTreeNode(targetArea)
      this.isLocate = false
      this.$nextTick(() => { this.$refs.zoneTree.setCheckedNodes(this.checkItems) })
    },
    goBackSearchList () {
      this.modeSearch = true
      this.isLocate = false
    },
    checkChange (data, checked, indeterminate) {
      if (this.showCheckbox) { // 区域多选模式
        if (this.leafLevel <= 2) { // 单级多选(树结构只有省一级的数据)
          let checkNodes = this.$refs.zoneTree.getCheckedNodes()
          this.checkItems = checkNodes
          // 清空 lastIdx 并重新计算
          this.lastIdx = null
          this.$nextTick(() => { this.isOverlength() })
        }
      } else { // 区域单选模式
        if (checked) {
          this.checkItems = [ data ] // 节点选中
          this.$nextTick(() => { this.$refs.zoneTree.setCheckedNodes(this.checkItems) })
        }
      }
    },
    // 多级多选模式下勾选逻辑由clickCheckBox方法处理
    clickCheckBox (data, { checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys }) {
      // 过滤掉从属关系后的逻辑意义上的已勾选行政区划数据
      const dependChecked = checkedNodes.filter(({ parentCode }) => checkedKeys.indexOf(parentCode) < 0)
      this.checkItems = dependChecked
      // 清空 lastIdx 并重新计算
      this.lastIdx = null
      this.$nextTick(() => { this.isOverlength() })
    },
    deleteItem (index) {
      if (this.checkItems[index]) {
        this.checkItems.splice(index, 1)
      }
      // 弹框展现时删除最后一项或弹框收起时删除任意项触发搜索
      if (!this.checkItems.length || !this.isShow) {
        this.emitItems = deepClone(this.checkItems)
        this.$emit('search', this.emitItems)
        if (this.$refs.elPopover) this.$refs.elPopover.doClose()
      }
      this.lastIdx = null
      this.$nextTick(() => {
        this.$refs.zoneTree.setCheckedNodes(this.checkItems)
        this.isOverlength()
      })
    },
    isOverlength () { // 计算已选项是否过多(是否超长)
      if (!this.isCheck) {
        this.needTip = false
        return
      }
      let box = this.$refs.itemBox
      if (box && box.scrollWidth >= box.offsetWidth) {
        if (this.showTip) this.needTip = true
        let tl = 0
        for (let i = 0; i < this.checkItems.length; i++) {
          let area = this.checkItems[i]
          let refKey = area[this.nodeKey]
          if (this.$refs[refKey][0]) {
            tl += this.$refs[refKey][0].offsetWidth + 5
            if (tl >= box.offsetWidth) {
              this.lastIdx = i >= 1 ? i : 0
              break
            }
          }
        }
      } else {
        this.needTip = false
      }
    },
    belongClass (level) {
      return {
        'item_belong': true,
        'prov': level === 2,
        'city': level === 3,
        'town': level === 4
      }
    },
    async loadNode (node, resolve) {
      this.isLoadData = true
      const { level, data, childNodes } = node
      if (childNodes.length) return resolve([])
      // 加载一级树形数据 及 非叶子节点的子元素
      if ((level === 0 || (data && data[this.levelKey] < this.leafLevel)) && this.loadChildren) {
        let subData = await this.loadChildren(node)
        if (level === 0 && this.checkFirst) { // 第一级数据加载完成并且需要默认选中第一个树节点
          let firstData = subData[0]
          this.checkItems = [firstData]
          this.$refs.zoneTree.setCheckedKeys([firstData[this.nodeKey]])
          this.emitItems = deepClone(this.checkItems)
        }
        resolve(subData)
      } else { // 叶子节点
        return resolve([])
      }
      this.isLoadData = false
    },
    async keywordSearch () {
      if (!this.searchKey) return
      this.isLocate = false
      this.modeSearch = true
      this.searchLoading = true
      this.searchList = []
      if (this.searchMethod) {
        this.searchList = await this.searchMethod(this.searchKey)
      }
      this.searchLoading = false
    },
    async locateTreeNode (nodeData) { // 定位到树中的特定节点
      if (!this.$refs.zoneTree) {
        let to = setTimeout(() => {
          clearTimeout(to)
          this.locateTreeNode(nodeData)
        }, 1000)
        return
      }
      this.modeSearch = false
      this.closeAllNode()
      let aimLevel = nodeData[this.levelKey]
      for (let i = 0; i < aimLevel - 1; i++) {
        if (i === 3 && TreeLayerCodes[i] === 'streetCode') continue // 如果是街道级别则略过
        let parentCode = nodeData[TreeLayerCodes[i]]
        if (!parentCode) {
          console.warn('不存在' + TreeLayerCodes[i] + ',查询结束', JSON.parse(JSON.stringify(nodeData)))
          break
        }
        await this.getSubData(parentCode)
      }
      let curKey = nodeData[this.nodeKey]
      this.$refs.zoneTree.setCurrentKey(curKey || nodeData[TreeLayerCodes[aimLevel - 2]])
      let st = setTimeout(() => {
        clearTimeout(st)
        let curNode = document.querySelector('.el-tree-node.is-current')
        if (curNode) {
          let curTop = curNode.offsetTop
          if (curTop > 20) curTop -= 10
          this.$refs.zoneTree.$el.scrollTo(0, curTop)
        } else {
          console.warn('查询current tree node 失败, current key:', curKey)
        }
      }, 300)
      this.isLocate = true
      this.locatedStr = this.searchKey
    },
    async getSubData (nodeCode) {
      let treeNode = this.$refs.zoneTree.getNode(nodeCode)
      if (!treeNode || treeNode.data[this.levelKey] >= this.leafLevel) return
      if (treeNode.childNodes.length) {
        treeNode.expanded = true
        return
      }
      // 设置默认展开的树节点(此操作将会触发 loadNode 方法)
      this.$refs.zoneTree.store.setDefaultExpandedKeys([nodeCode])
      let vm = this
      return new Promise((resolve, reject) => {
        let inte = setInterval(() => {
          if (!vm.isLoadData) { // 节点数据加载完成
            clearInterval(inte)
            resolve()
          } else {
          }
        }, 500)
      })
    },
    closeAllNode () { // 收起所有树节点
      let nodesMap = this.$refs.zoneTree.store.nodesMap // node-key与树节点的映射对象
      for (let key in nodesMap) {
        if (nodesMap[key].expanded) nodesMap[key].expanded = false
      }
    },
    clearSearch () {
      this.searchList = []
      this.modeSearch = false
      this.isLocate = false
    },
    abandSelect () {
      this.checkItems = deepClone(this.emitItems)
      if (this.$refs.elPopover) this.$refs.elPopover.doClose()
      this.$nextTick(() => { this.isOverlength() })
    },
    confirmAction () {
      this.clearSearch()
      this.searchKey = ''
      this.emitItems = deepClone(this.checkItems)
      this.$emit('search', this.emitItems)
      if (this.$refs.elPopover) this.$refs.elPopover.doClose()
    }
  }
}
</script>

<style lang="scss">
.zone_pop_box {
  height: 410px;
  padding: 20px 0 0;
  .zone_key_word {
    color: #FF3973;
    font-weight: 600;
  }
}
</style>
<style lang="scss" scoped>
.pop_wrap {
  display: inline-block;
  cursor: pointer;
  position: relative;
  vertical-align: bottom;
  &.in_drop {
    margin-top: 18px;
    width: 100%;
  }
}
.show_select {
  line-height: normal;
  font-size: 12px;
  outline: none;
  .el-icon-arrow-down {
    color: #C0C4CC;
    vertical-align: middle;
    transition: transform .3s;
    &.small {
      line-height: 28px;
    }
    &.fix_right {
      position: absolute;
      top: 5px;
      right: 0;
    }
    &.reverse {
      transform: rotateZ(180deg);
    }
  }
  .sel_items {
    display: inline-block;
    color: #3B3F45;
    line-height: 1;
    width: calc(100% - 14px);
    overflow: hidden;
    vertical-align: top;
    white-space: nowrap;
    &.in_drop {
      width: calc(100% - 10px);
    }
    .holder_item {
      color: #c0c4cc;
      display: inline-block;
      line-height: 50px;
      margin-right: 5px;
      &.small {
        line-height: 28px;
      }
      &.in_drop {
        line-height: 24px;
      }
    }
    .item_box {
      &.small {
        line-height: 28px;
        .s_item {
          line-height: 28px;
          margin-right: 5px;
        }
      }
    }
    .s_item {
      color: #3B3F45;
      display: inline-block;
      position: relative;
      line-height: 20px;
      padding-right: 8px;
      margin-right: 10px;
      vertical-align: top;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.in_drop {
        line-height: 22px;
        max-width: 80px;
      }
      &.divide {
        margin-right: 0;
        padding-right: 0;
      }
      &.hide {
        display: none;
      }
      .icon-shibai {
        color: #F32F2F;
        font-size: 12px;
        line-height: 1;
        position: absolute;
        top: -1px;
        right: 0;
        transform: scale(0.8334);
        &.small {
          top: 1px;
        }
      }
    }
  }
}
.content_box {
  height: 100%;
  padding: 0 20px;
  .search_input {
    margin-bottom: 10px;
    ::v-deep .el-input__inner {
      color: #3B3F45;
      height: 30px;
    }
    .el-icon-search {
      cursor: pointer;
    }
  }
  .back_btn {
    color: #FF3973;
    cursor: pointer;
    height: 26px;
    line-height: 26px
  }
  .zone_tree {
    height: calc(100% - 80px);
    overflow: scroll;
    &.located { // 搜索结果定位到树节点状态，出现返回按钮(26px)
      height: calc(100% - 116px);
    }
    &.in_drop {
      ::v-deep .el-tree-node__expand-icon.is-leaf {
        width: 0;
      }
    }
  }
  .btn_group {
    position: relative;
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
      content: '';
      background: #EAEBF0;
      position: absolute;
      top: 0;
      left: -20px;
      right: -20px;
      height: 1px;
    }
    .btn_item {
      position: relative;
      color: #282729;
      cursor: pointer;
      width: 50%;
      height: 100%;
      text-align: center;
      &:not(:last-child) {
        &::after {
          content: '';
          background: #EAEBF0;
          width: 1px;
          position: absolute;
          right: 0;
          top: 10px;
          bottom: 10px;
        }
      }
      &.confirm {
        color: #FF3973;
      }
    }
  }
}
.search_result {
  height: calc(100% - 80px);
  font-size: 12px;
  padding: 0 10px;
  .excess_tip {
    color: #878A92;
    height: 26px;
    line-height: 26px;
  }
  .no_result {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .has_result {
    height: 100%;
  }
  .result_ul {
    color: #3B3F45;
    height: 100%;
    overflow: scroll;
    &.many {
      height: calc(100% - 26px);
    }
    .ul_item {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 26px;
      line-height: 26px;
      &:hover {
        background: #F9F9F9;
      }
    }
    .item_name {
      line-height: 18px;
      max-width: calc(100% - 66px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .item_belong {
      background: #F3F3F6;
      border-radius: 2px;
      color: #4B4F58;
      width: 60px;
      line-height: 16px;
      padding: 0 6px;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
      text-overflow: ellipsis;
      &.prov {
        background: rgba(223, 4, 4, 0.15);
        color: #DC3A3A;
      }
      &.city {
        background: rgba(48, 131, 242, 0.15);
        color: #FF3973;
      }
      &.town {
        background: rgba(81, 200, 70, 0.15);
        color: #51C846;
      }
    }
  }
}
</style>
